import { useMutation, useQueryClient } from '@tanstack/react-query';
import { patchCenterSettlementType } from './api';
import { PatchSettlementTypeBody } from './types';

export const usePatchCenterSettlementType = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: ({
            centerId,
            body,
        }: {
            centerId: string;
            body: PatchSettlementTypeBody;
        }) => patchCenterSettlementType({ centerId, body }),
        onSuccess: () => {
            // 정산 모드 전환 시 급여계산/정산 화면이 이전 모드 수치를 보이지 않도록 재조회
            queryClient.invalidateQueries({ queryKey: ['getSalaryCalcsQuery'] });
            queryClient.invalidateQueries({
                queryKey: ['getClassFeeSettlementForMembershipQuery'],
            });
        },
    });
};
